import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

//-- Hoc
import Layout from './../../hoc/Layout/Layout';

//-- Containers
import Avatar from './../../containers/UI/Avatar/Avatar';
import Footer from './../../containers/Navigation/Footer/Footer';
import TinyJellyShape from './../../containers/UI/Common/JellyShape/TinyJellyShape';

//-- Components
import ProductsList from './ProductList/ProductList';
import ProductDetails from './ProductDetails/ProductDetails';

//-- Utils
import { pushPageView } from './../../utils/tracking/customGtm';
import { pushHeaderTitle } from './../../utils/dom/helper';

class StorePage extends Component {

    state = {
        displayMode:"carousel", // carousel or details
    }

    componentDidMount = () => {
        //-- Update title
        pushHeaderTitle('Boutique');

        //-- Push GTM page view
        pushPageView();
    }

    /**
     * Handler
     */

    handlerClose = () => {
        this.props.push('/account/profile');
    }

    popDetailsShow = () => {
        this.setState({displayMode: 'details'});
    }

    backToList = () => {
        this.setState({displayMode: 'carousel'});
    }

    render = () => {
        return <Layout layoutClass="store-page">
                { this.state.displayMode === 'carousel' &&
                    <header>
                        <TinyJellyShape color={"gradient"} />
                        <div className="store-title"></div>
                        <div className="close-page" onClick={this.handlerClose}></div>
                    </header> }
                { this.state.displayMode === 'carousel' &&
                    <div className="main-products">
                        <ProductsList 
                            popDetailsShow={this.popDetailsShow}
                        />
                    </div> }
                { this.state.displayMode === 'details' &&
                    <ProductDetails
                        backToList={this.backToList}
                        /> }
                <Footer classes='store-footer'>
                <span >
                    <Avatar 
                        avatarName={this.props.user.avatar}
                        userName={this.props.user.username}
                        isEditable={false}
                        
                        imgClick={this.handlerClose}
                        
                        badgeUser={this.props.points.currentPoints} />
                        <div className="store-points">
                            { this.props.points.currentPoints }
                        </div>
                </span>
            </Footer>
        </Layout>;
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        points: state.points
    }
}

const mapStateToDispatch = dispatch => {
    return {
        'push' : (url) => { dispatch(push(url)) }
    }
}

export default connect( mapStateToProps, mapStateToDispatch )(StorePage);


// WEBPACK FOOTER //
// ./src/components/StorePage/StorePage.js